import { createSelector } from '@reduxjs/toolkit';
import type { IMyPerformanceState, WidgetKey } from './MyPerformance.redux';

const selectDomain = (state: { myPerformance?: IMyPerformanceState }) => state.myPerformance ?? ({} as IMyPerformanceState);

export const selectMyPerformanceData = createSelector(
  [selectDomain],
  (s) => s.data ?? null,
);

export const selectMyPerformanceWidgetLoaded = createSelector(
  [selectDomain],
  (s) => s.widgetLoaded ?? {},
);

export const selectMyPerformanceLoadError = createSelector(
  [selectDomain],
  (s) => s.loadError ?? false,
);

export const selectRecruiterOptions = createSelector(
  [selectDomain],
  (s) => s.recruiterOptions ?? [],
);

export const selectSelectedEmployeeId = createSelector(
  [selectDomain],
  (s) => s.selectedEmployeeId ?? null,
);

export const selectWidgetLoaded = (widget: WidgetKey) =>
  createSelector([selectMyPerformanceWidgetLoaded], (loaded) => loaded[widget] === true);
